import React from 'react'
import Reflux from 'reflux-react-16'
import {Route} from 'react-router-dom'

import LoginStore from '../stores/LoginStore.js'
import LoginActions from '../actions/LoginActions.js'
import OrderStore from '../stores/OrderStore.js'

import {NavBar, Container, NavButton, TopBar} from '../components/UI/index.js'
import {Button, Colors, IconButton, P, Popup, Row, Badge, Card} from '../../src/components/UI/index.js'
import NotificationsPopup from '../../src/components/communication/NotificationsPopup.js'
import geolocation from '../utils/geolocation.js'

import AddressList from './AddressList.js'
import Map from './Map.js'
import Scan from './Scan.js'
import Stop from '../views/Stop.js'
import Settings from './Settings.js'
import NotificationsPage from '../../src/components/communication/NotificationsPage.js'
import RouteOverview from './RouteOverview.js'
import ShiftOverview from './ShiftOverview.js'
import NavApps from '../utils/NavApps.js'
import Languages from '@utils/Languages.js'
import ShiftActivityPopup from '@components/ShiftActivityPopup.js'
import {emit} from 'messenger/socketio/socketEmit.js'
import utils from '../utils/utils.js'
import t from 'src/helpers/Languages.js'
import OrderActions from 'messenger/actions/OrderActions.js'
import calcDistance from '@utils/calcDistance.js'
import {formSpacing} from '../../src/components/UI/forms/index.js'

class Layout extends Reflux.Component {
    constructor(props) {
        super(props)

        this.state = {showInstallBanner: null, deferredPrompt: null, pauseResumeBusy: false}

        this.stores = [LoginStore, OrderStore]
    }

    componentDidMount() {
        const {history} = this.props

        document.title = 'Koerier'

        LoginActions.loggedIn((loggedIn) => {
            if (!loggedIn) {
                history.push('/koerier/login')
            } else {
                LoginActions.checkNotifications(() => {
                    this.notificationsPopup?.checkIfNewNotification()
                })
            }
        })

        window.addEventListener('beforeinstallprompt', (event) => {
            const {showInstallBanner} = this.state

            if (!showInstallBanner) {
                this.setState({showInstallBanner: true, deferredPrompt: event})
            }
        })
    }

    async componentDidUpdate(prevProps, prevState) {
        const {history} = this.props
        let {reseller, shift, route, location} = this.state

        if (history.location.pathname === '/koerier' || history.location.pathname === '/koerier/') {
            if (reseller?.permissions?.shifts) {
                history.push('/koerier/dienst')
            } else {
                history.push('/koerier/route')
            }
        }

        // If shiftRequired is enabled and a shift is assigned, but not started, redirect to the shift overview page. Also redirect if a shift was assigned and now is no longer assigned.
        if (reseller?.settings?.shifts?.shiftRequired && ((!prevState.shift && shift && !shift.started) || (prevState.shift && !shift))) {
            history.push('/koerier/dienst')
        }

        /**
         * If the route has been completed and autoCompleteRoutes is enabled, start the stopRoute activity and redirect to overview
         * Not sure if this is the best way to do this, but it works for now.
         * We check if the route has been completed by comparing the previous state with the current state,
         * because the route object is updated when the route is completed, so we can check if the completed property has changed from false to true.
         */
        // Only when the selected route itself changed from not completed to completed, not when switching to an already completed route
        const routeJustCompleted = prevState.route?._id && prevState.route._id === route?._id && !prevState.route.completed && route?.completed

        if (shift?._id && reseller?.settings?.orders?.autoCompleteRoutes && routeJustCompleted) {
            const activityId = reseller?.settings?.shifts?.activities?.find((activity) => activity.trigger === 'other')?.id

            if (activityId) {
                if (!location?.lat) {
                    location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
                }

                try {
                    await emit('shifts.startActivity', {id: shift._id, activityId, location})
                } catch (error) {
                    console.error(error)
                }
            }

            history.push('/koerier/route')
        }

        if (routeJustCompleted) {
            this.onRouteCompleted()
        }
    }

    onClickInstall() {
        const {deferredPrompt} = this.state

        deferredPrompt.prompt()

        deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt')
            } else {
                console.log('User dismissed the A2HS prompt')
            }

            this.setState({showInstallBanner: false, deferredPrompt: null})
        })
    }

    async onClickNavigation(user, route, address) {
        let {settings: {navigationApp = 'googleMaps', transportType = 'routeVehicle'}} = user

        // Use the route vehicle when no (valid) transport type is chosen
        if (!NavApps[navigationApp].transportTypes.some((type) => type.value === transportType)) {
            transportType = NavApps[navigationApp].transportType[route.vehicleType] || NavApps[navigationApp].transportTypes[0].value
        }

        const openUrl = (url) => {
            const os = utils.getMobileOperatingSystem()
            if (os === 'iOS') {
                window.location.href = url
            } else {
                window.open(url, '_self')
            }
        }

        if (navigationApp === 'googleMaps') {
            const url = `https://www.google.com/maps/dir/?api=1&destination=${utils.navigationDestination(address, {dropLongAddition: true})}&travelmode=${transportType}`
            openUrl(url)
        } else if (navigationApp === 'appleMaps') {
            openUrl(`http://maps.apple.com/?daddr=${utils.navigationDestination(address)}&dirflg=${transportType}`)
        } else if (navigationApp === 'mapsme') {
            try {
                const position = await geolocation.getCurrentPosition(true)
                openUrl(`mapsme://route?sll=${position.lat},${position.lng}&saddr=&dll=${address.position.lat},${address.position.lng}&daddr=${utils.navigationDestination(address)}&type=${transportType}`)
            } catch (err) {
                alert(err)
            }
        } else if (navigationApp === 'tomtomgo') {
            openUrl(`tomtomgo://x-callback-url/navigate?destination=${address.position.lat},${address.position.lng}`)
        } else if (navigationApp === 'sygic') {
            openUrl(`com.sygic.aura://coordinate%7C${address.position.lng}%7C${address.position.lat}%7C${transportType}`)
        } else if (navigationApp === 'waze') {
            openUrl(`https://www.waze.com/ul?ll=${address.position.lat},${address.position.lng}&navigate=yes`)
        } else if (navigationApp === 'organicMaps') {
            try {
                const position = await geolocation.getCurrentPosition(true)

                if (position && address.position) {
                    openUrl(`om://route?sll=${position.lat},${position.lng}&saddr=Start%20Point&dll=${address.position.lat},${address.position.lng}&daddr=EndPoint&type=${transportType}`)
                } else if (!address.position) {
                    throw new Error(t('addressCoordinatesUnknown'))
                }
            } catch (err) {
                alert(err)
            }
        } else if (navigationApp === 'osmand') {
            try {
                if (address.position) {
                    openUrl(`https://osmand.net/map?end=${encodeURIComponent(`${address.position.lat},${address.position.lng}`)}&mode=${transportType}`)
                } else {
                    throw new Error(t('addressCoordinatesUnknown'))
                }
            } catch (err) {
                alert(err)
            }
        }
    }

    // The Pauze/Hervat button shows a spinner and ignores taps until the action is done or failed, so it can't be sent twice
    async onClickPauseResumeShift() {
        if (this.state.pauseResumeBusy) return

        this.setState({pauseResumeBusy: true})

        try {
            if (this.state.shift?.paused) {
                await this.onClickResumeShift()
            } else {
                await this.onClickPauseShift()
            }
        } finally {
            this.setState({pauseResumeBusy: false})
        }
    }

    async onClickPauseShift() {
        let {reseller, shift, location} = this.state
        try {
            if (!location?.lat) {
                location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
            }

            await emit('shifts.pauseShift', {id: shift._id, location})
        } catch (err) {
            console.error(err)
            this.popup.setError(t('shiftPauseFailed'))
        }
    }

    async onClickResumeShift() {
        let {reseller, shift, location} = this.state

        try {
            if (!location?.lat) {
                location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
            }

            await emit('shifts.resumeShift', {id: shift._id, location})
        } catch (err) {
            console.error(err)
            this.popup.setError(t('shiftResumeFailed'))
        }
    }

    async onClickSwitchActivity() {
        let {reseller, location, shift} = this.state

        const activityId = await this.shiftActivityPopup.open(shift)

        // Closed without choosing
        if (!activityId) {
            return
        }

        if (!location?.lat) {
            location = await geolocation.getCurrentPosition(reseller.settings.shifts.gpsRequired)
        }

        try {
            await emit('shifts.startActivity', {id: shift._id, activityId, location})
        } catch (error) {
            console.error(error)
        }
    }

    async onRouteCompleted() {
        const {history} = this.props
        let {reseller, shift, location} = this.state

        if (!shift || shift.completed) {
            return
        }

        this.popup.setActionButtons([
            {
                variant: 'outline-white',
                label: t('newRoute'),
                onClick: async () => {
                    const {route} = this.state

                    const lastNr = route?.name.match(/(?:-\s*)?(\d+)$/)?.[1]
                    const newName = `${route?.name.replace(/\s*(?:-\s*)?\d+$/, '')} - ${lastNr ? parseInt(lastNr, 10) + 1 : 2}`

                    try {
                        const newRoutedId = await emit('orders.copyRoute', route._id, newName)
                        OrderActions.selectRoute(newRoutedId)
                        history.push('/koerier/route')
                        this.popup?.close()
                    } catch (err) {
                        this.popup.setError(err.toString())
                    }
                }
            },
            {
                variant: 'outline-white',
                label: t('endShift'),
                onClick: async () => {
                    try {
                        let isConfirmed = false

                        const hasActiveRoute = Object.values(this.state.routes || {}).some((route) => route.started && !route.completed)

                        if (hasActiveRoute) {
                            this.popup.close() // close current popup to show error message in a new popup
                            this.popup.setError(t('shiftEndBlockedByActiveRoute'))
                            if (!await this.popup.open(t('endShift'), '')) return
                            return
                        }

                        if (reseller.settings.shifts.gpsRequired) {
                            await geolocation.checkPermissions()
                        }

                        if (reseller.settings.shifts.deviateEndLocation && shift?.endPoint) {
                            if (!location?.lat) {
                                location = await geolocation.getCurrentPosition(true)
                            }

                            if (location) {
                                const distance = calcDistance(location, shift?.endPoint.position)

                                const isOutsideRadius = distance > (reseller.settings.shifts.maxStartEndLocationDeviation || 100) + location.accuracy

                                if (reseller.settings.shifts.deviateEndLocation === 'notallowed' && isOutsideRadius) {
                                    this.popup.close() // close current popup to show error message in a new popup
                                    this.popup.setError(`Je bevind je niet binnen ${reseller.settings.shifts.maxStartEndLocationDeviation || 100} meter van de eindlocatie, dienst kan niet worden afgerond.`)
                                    if (!await this.popup.open('Dienst afronden', '')) return
                                    return
                                }

                                if (reseller.settings.shifts.deviateEndLocation === 'warning' && isOutsideRadius) {
                                    this.popup.close() // close current popup to show warning message in a new popup
                                    this.popup.setWarning(`Je bevind je niet binnen ${reseller.settings.shifts.maxStartEndLocationDeviation || 100} meter van de eindlocatie.`)
                                    isConfirmed = await this.popup.open('Dienst afronden', 'Je dienst wordt afgerond en kan niet meer worden vervolgd. Weet je zeker dat je door wil gaan?')

                                    if (!isConfirmed) {
                                        return
                                    }
                                }
                            }
                        }

                        await emit('shifts.endShift', {id: shift?._id, location})
                        history.push('/koerier/dienst')
                        this.popup?.close()
                    } catch (err) {
                        await this.popup.setError(err.message || err?.toString())
                    }
                }
            }
        ])
        if (!await this.popup.open('Route afgerond', (
            <div>
                <P>Je route is afgerond. De dienst is nog actief.</P>
                <br />
                <P>Kies hier om verder te gaan met een nieuwe route of om de dienst af te ronden.</P>
            </div>
        ))) return
    }

    render() {
        let {reseller, user, shift, showInstallBanner, notifications, branding} = this.state
        const {history} = this.props

        const currentActivity = shift && reseller.settings.shifts?.activities?.find((activity) => activity.id === shift.activityId)

        showInstallBanner = false // Disable install banner

        return (
            <Container style={{height: '100svh', background: Colors.backgroundNeutral, paddingTop: 50}}>
                {showInstallBanner &&
                    <Card shadow style={{position: 'fixed', zIndex: 999999, display: 'flex', alignItems: 'center', gap: formSpacing.tight, width: '98%', margin: 6, top: 0}}>
                        <IconButton onClick={() => this.setState({showInstallBanner: false})}>
                            <i className='mdi mdi-close' />
                        </IconButton>

                        <P>Installeer als app voor een betere gebruikservaring.</P>

                        <Button variant='text' onClick={this.onClickInstall.bind(this)} label='INSTALLEER' />
                    </Card>
                }

                <TopBar reseller={reseller} user={user} history={history} showLogo={true} showAccount={true} branding={branding} />

                <div style={{display: 'flex', flexDirection: 'column', flex: 1, width: '100%', minHeight: 0}}>
                    <Route path='/koerier/route' render={(props) => <RouteOverview {...props} reseller={reseller} user={user} branding={branding} />} />
                    <Route path='/koerier/dienst' render={(props) => <ShiftOverview {...props} reseller={reseller} user={user} branding={branding} />} />
                    <Route path='/koerier/adressen' render={(props) => <AddressList {...props} onClickNavigation={this.onClickNavigation} reseller={reseller} user={user} branding={branding} />} />
                    <Route path='/koerier/kaart' render={(props) => <Map {...props} reseller={reseller} onClickNavigation={this.onClickNavigation} user={user} branding={branding} />} />
                    <Route path='/koerier/scan' render={(props) => <Scan {...props} reseller={reseller} user={user} branding={branding} />} />

                    <Route path={['/koerier/ophalen/:orderId/:addressIndex', '/koerier/bezorgen/:orderId/:addressIndex']} render={(props) => <Stop {...props} onClickNavigation={this.onClickNavigation} reseller={reseller} user={user} branding={branding} shift={shift} />} />
                    <Route path='/koerier/bundel/:orderId/:addressIndex' render={(props) => <Stop {...props} bundle onClickNavigation={this.onClickNavigation} reseller={reseller} user={user} branding={branding} shift={shift} />} />

                    <Route path='/koerier/instellingen' render={(props) => <Settings {...props} reseller={reseller} user={user} />} />
                    <Route path='/koerier/meldingen' render={(props) => <NotificationsPage {...props} reseller={reseller} user={user} notifications={notifications} />} />
                </div>

                {['/koerier/dienst', '/koerier/route', '/koerier/adressen', '/koerier/kaart'].includes(history.location.pathname) &&
                    <Row style={{marginBottom: 6, marginTop: 6, flexDirection: 'column', alignItems: 'center'}}>
                        {(currentActivity || shift?.paused) &&
                            <Badge
                                color={shift?.paused ? Colors.grey40 : currentActivity?.color}
                                style={{width: 'calc(100vw - 12px)', justifyContent: 'center'}}
                            >
                                {`${Languages.currentActivity['NL']}: ${shift?.paused ? Languages.pause['NL'] : currentActivity?.name}`}
                            </Badge>
                        }

                        {reseller.settings.shifts?.shiftRequired && !shift &&
                            <Badge
                                color={Colors.grey40}
                                style={{width: 'calc(100vw - 12px)', justifyContent: 'center'}}
                            >
                                {Languages.noShift['NL']}
                            </Badge>
                        }

                        {shift && !shift.started && !shift.completed &&
                            <Badge
                                variant='white'
                                style={{width: 'calc(100vw - 12px)', justifyContent: 'center'}}
                            >
                                {Languages.shiftNotStarted['NL']}
                            </Badge>
                        }

                        {shift?.completed &&
                            <Badge
                                variant='success'
                                style={{width: 'calc(100vw - 12px)', justifyContent: 'center'}}
                            >
                                {Languages.shiftCompleted['NL']}
                            </Badge>
                        }

                        {shift && shift?.started && !shift?.completed &&
                            <Row style={{marginTop: 6, columnGap: formSpacing.columnGap, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                <Button
                                    variant={shift?.paused ? 'solid' : 'outline-white'}
                                    color={shift?.paused ? branding?.color || Colors.brandColor : undefined}
                                    style={{flex: 1}}
                                    size='lg'
                                    icon={shift?.paused ? 'mdi mdi-play' : 'mdi mdi-pause'}
                                    label={shift?.paused ? t('resume') : t('pause')}
                                    disabled={!shift || !shift?.started || shift?.completed}
                                    loading={this.state.pauseResumeBusy}
                                    onClick={() => this.onClickPauseResumeShift()}
                                />

                                <Button
                                    variant='outline-white'
                                    style={{flex: 1}}
                                    size='lg'
                                    icon='mdi mdi-swap-horizontal'
                                    label={Languages.switchActivity['NL']}
                                    disabled={!shift || shift?.completed}
                                    onClick={() => this.onClickSwitchActivity()}
                                />
                            </Row>
                        }
                    </Row>
                }

                {['/koerier', '/koerier/dienst', '/koerier/route', '/koerier/adressen', '/koerier/kaart', '/koerier/scan'].includes(history.location.pathname) &&
                    <NavBar>
                        {reseller?.permissions?.shifts &&
                            <NavButton
                                active={history.location.pathname === '/koerier/dienst'}
                                label={t('shift')}
                                icon='mdi mdi-calendar-clock'
                                onClick={() => history.push('/koerier/dienst')}
                            />
                        }

                        <NavButton
                            active={history.location.pathname === '/koerier/route'}
                            label='Route'
                            icon='mdi mdi-transit-connection-variant'
                            disabled={reseller?.settings?.shifts?.shiftRequired && !shift?.started}
                            onClick={() => history.push('/koerier/route')}
                        />
                        <NavButton
                            active={history.location.pathname === '/koerier/adressen'}
                            label='Adressen'
                            icon='mdi mdi-format-list-bulleted'
                            disabled={reseller?.settings?.shifts?.shiftRequired && !shift?.started}
                            onClick={() => history.push('/koerier/adressen')}
                        />
                        <NavButton
                            active={history.location.pathname === '/koerier/kaart'}
                            label='Kaart'
                            icon='mdi mdi-map'
                            disabled={reseller?.settings?.shifts?.shiftRequired && !shift?.started}
                            onClick={() => history.push('/koerier/kaart')}
                        />
                        <NavButton
                            active={history.location.pathname === '/koerier/scan'}
                            label='Scannen'
                            icon='mdi mdi-barcode-scan'
                            disabled={reseller?.settings?.shifts?.shiftRequired && !shift?.started}
                            onClick={() => history.push('/koerier/scan')}
                        />
                    </NavBar>
                }

                <Popup ref={(ref) => this.popup = ref} />

                <NotificationsPopup
                    user={user}
                    onClickReadNotifications={LoginActions.updateReadNotifications}
                    notifications={notifications}
                    ref={(ref) => this.notificationsPopup = ref}
                />

                <ShiftActivityPopup ref={(ref) => this.shiftActivityPopup = ref} reseller={reseller} />
            </Container>
        )
    }
}

export default Layout
